
import { useState, useRef, useEffect } from "react";
import { Wheel } from "react-custom-roulette";
import { Box, Container, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs";
import { useSettingsContext } from "src/components/settings";
import Confetti from "react-confetti";
import { useBoolean } from "src/hooks/use-boolean";
import Iconify from "src/components/iconify";

const participants = ["Alice", "Bob", "Charlie", "David", "Eve", "Frank", "Grace", "Hannah", "Isaac", "Jack"];
const data = participants.map((name, index) => ({ option: name, id: index }));

const GiveawayResult = () => {
    
    const spinning = useBoolean();
    const openDialog = useBoolean();
    const showCelebration = useBoolean();
    const [prizeIndex, setPrizeIndex] = useState(null);
    const [winner, setWinner] = useState(null);
    const spinSound = useRef(new Audio("https://www.fesliyanstudios.com/play-mp3/438"));
    const celebrationSound = useRef(new Audio("https://www.fesliyanstudios.com/play-mp3/3024"));
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const settings = useSettingsContext();

    const startDraw = () => {
        if (spinning.value) return;
        const randomIndex = Math.floor(Math.random() * participants.length);
        setPrizeIndex(randomIndex);
        spinning.onTrue();
        setWinner(null);
    };

    useEffect(() => {
        startDraw();
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleStopSpinning = () => {
        spinning.onFalse();
        openDialog.onTrue();
        const selectedWinner = participants[prizeIndex];
        setWinner(selectedWinner);
        showCelebration.onTrue();

        spinSound.current.currentTime = 0;
        // celebrationSound.current.play();



        setTimeout(() => {
            showCelebration.onFalse();
        }, 10000);
    };

    return (
        <Container maxWidth={settings.themeStretch ? false : "xl"}>
            <CustomBreadcrumbs
                heading="Giveaway Result - Wheel"
                links={[
                    { name: "Dashboard", href: "/dashboard" },
                    { name: "Giveaway", href: "/dashboard/giveaway" },
                    { name: "Giveaway Result" },
                ]}
                sx={{ pb: 2 }}
            />

            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", mt: 4 }}>
                <Wheel
                    mustStartSpinning={spinning.value}
                    prizeNumber={prizeIndex}
                    onStopSpinning={handleStopSpinning}
                    data={data}
                    backgroundColors={["#FF5722", "#4CAF50", "#1976D2", "#FFC107"]}
                    textColors={["#FFFFFF"]}

                />
            </Box>

            {/* Winner Announcement Dialog */}
            <Dialog open={openDialog.value} onClose={() => openDialog.onFalse()} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ fontWeight: "bold", textAlign: "center", fontSize: "2rem", }}>
                    <img src="/assets/congratulationIcon.png" alt="congratulations"/>
                    <Typography color={"primary"} variant="h4" sx={{ textShadow: "1px 1px 4px rgba(0,0,0,0.3)" }}>Congratulations</Typography>
                </DialogTitle>
                <DialogContent sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Box>
                        <Typography variant="h4" color={"primary"} sx={{ fontWeight: "bold", textShadow: "1px 1px 4px rgba(0,0,0,0.3)", textAlign: "center" }}>
                            <Iconify icon="solar:cup-outline" color="primary" width={30} height={30} /> {winner}  <Iconify icon="solar:cup-outline" color="primary" width={30} height={30} />
                        </Typography>
                        <Typography variant="subtitle1" sx={{ opacity: 0.9, mt: 1 }}>
                            You are the lucky winner!
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button fullWidth
                        color="primary"
                        sx={{ paddingY: 2 }}
                        onClick={() => openDialog.onFalse()}
                        variant="contained"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confetti Celebration */}
            {showCelebration.value && <Confetti width={windowSize.width} height={windowSize.height} numberOfPieces={400} />}


        </Container>
    );
};

export default GiveawayResult;


